<template>
   <nav class="navbar navbar-expand-lg navbar-dark bg-dark rounded">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar1" aria-controls="navbar1"
      aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-md-center" id="navbar1">
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link class="nav-link" to="/">Kezdőoldal</router-link>
        </li>
        <!-- <li v-if="auth === 'loggedin' && userType === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/munkalap">Munkalap</router-link>
        </li> -->
        <li v-if="(auth === '' || auth === undefined) && (token == null || token == undefined)" class="nav-item">
          <router-link class="nav-link" to="/login">Bejelentkezés</router-link>
        </li>
        <li v-if="auth === 'loggedin' && userType === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/register">Felhasználók</router-link>
        </li>
        <li v-if="auth === 'loggedin' && (userType === 'admin' || userType === 'user' || userType === 'gyartas')" class="nav-item">
          <router-link class="nav-link" to="/munkak">Munkalapok</router-link>
        </li>
        <li v-if="auth === 'loggedin' && (userType === 'admin' || userType === 'user' || userType === 'gyartas')" class="nav-item">
          <router-link class="nav-link" to="/nyomdaimunkak">Nyomdai munkák</router-link>
        </li>
        <li v-if="auth === 'loggedin' && userType === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/cikkek">Egyéb tételek</router-link>
        </li>
        <li v-if="auth === 'loggedin' && userType === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/megmunkalasok">Megmunkálások</router-link>
        </li>
        <li v-if="auth === 'loggedin' && userType === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/status">Státuszok</router-link>
        </li>
        <li v-if="auth === 'loggedin' && userType === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/anyagtipusok">Anyag+kivitel</router-link>
        </li>
        <li v-if="auth === 'loggedin' && (userType === 'admin' || userType === 'user')" class="nav-item">
          <router-link class="nav-link" to="/calculator">Új munkalap</router-link>
        </li>
        <li v-if="auth === 'loggedin' && (userType === 'admin' || userType === 'user' || userType === 'gyartas')" class="nav-item">
          <router-link class="nav-link" to="/profile">Saját fiók</router-link>
        </li>
        <li v-if="auth === 'loggedin' && (userType === 'admin' || userType === 'user' || userType === 'gyartas')" class="nav-item">
          <a class="nav-link" href="" v-on:click="logout">Kilépés</a>
        </li>
      </ul>
    </div>
  </nav>
  <!-- <div>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="#">BrandMax</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="auth=='' && (token==null || token==undefined)" @click="$router.push('login')">Bejelentkezés</b-nav-item>
          <b-nav-item v-if="auth=='loggedin' || token!=null || token!=undefined" href="/munkak">Munkalapok</b-nav-item>
          <b-nav-item href="#">Árkalkulátor</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
          </b-nav-form>

          <b-nav-item-dropdown text="Törzsadatok">
            <b-dropdown-item href="#">Cikkek</b-dropdown-item>
            <b-dropdown-item href="#">Státuszok</b-dropdown-item>
            <b-dropdown-item href="#">Anyagtípusok</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <em>Felhasználó</em>
            </template>
            <b-dropdown-item href="#">Saját fiók</b-dropdown-item>
            <b-dropdown-item v-if="auth=='loggedin' || token!=null || token!=undefined" v-on:click="logout">Kijelentkezés</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div> -->
</template>

<script>

import EventBus from './EventBus'
import jwtDecode from 'jwt-decode'
import router from '../router'

export default {
  data: () => {
    return {
      auth: '',
      token: localStorage.usertoken,
      userType: '',
      remainingTime: ''
    }
  },

  methods: {
    logout () {
      localStorage.removeItem('usertoken')
      localStorage.removeItem('userType')
      localStorage.removeItem('auth')
      this.auth = ''
      this.userType = ''
      this.token = null
      // Ellenőrizzük, hogy a felhasználó már a 'Home' oldalon van-e
      if (this.$route.name !== 'Home') {
        router.push({ name: 'Home' });
      }
    },

    calculateRemainingTime () {
      if (this.token) {
        const decoded = jwtDecode(this.token)
        const currentTime = Date.now() / 1000 // Aktuális idő másodpercben
        const expTime = decoded.exp // Token lejárati idő
        const timeLeft = expTime - currentTime

        if (timeLeft > 0) {
          const minutes = Math.floor(timeLeft / 60)
          const seconds = Math.floor(timeLeft % 60)
          this.remainingTime = `${minutes}:${seconds}`
        } else {
          this.remainingTime = 'Token lejárt'
          this.logout() // Kijelentkezés, ha lejárt
        }
      }
    }
  },
  mounted () {
    EventBus.$on('logged-in', status => {
      this.auth = status
      this.userType = localStorage.userType
      this.token = localStorage.usertoken
      console.log(this.token)
      this.calculateRemainingTime() // Azonnali számláló indítás bejelentkezés után
    })
    this.userType = localStorage.userType
    this.auth = localStorage.auth
    if (this.token) {
      this.calculateRemainingTime() // Esetleg itt is indíthatjuk, ha már be van jelentkezve
    }
    setInterval(this.calculateRemainingTime, 1000) // Frissítés 1 másodpercenként
  }

}
</script>




// WEBPACK FOOTER //
// src/components/Navbar.vue